module.exports = __webpack_public_path__ + "img/_empty_states_appointment.f26dddfc.svg";